const createMixins = () => ({
  toolbar: {
    minHeight: 62
  }
});

export default createMixins;
